import React from "react";
import './answer.css';
import ContextData from './../../context/Data/ContextData';
import { useNavigate } from 'react-router-dom'; 
import Questions from '../../include/Questions/Questions'; 

const Answer = () => {   
    const {stateData, dispatchData} = React.useContext(ContextData);
    let navigate = useNavigate();

    React.useEffect(() => { 
        if(stateData.contextUserAnswers[0] === -1) {    
            return navigate("../", { replace: true });
        }
    });

 
  return ( 
    <> 
        <Questions/>
        <div className="answer">
            <div className="answer__grid" />
            <div className="answer__content">
                <div className="answer__top">
                    <div className="answer__ava"><img src={"assets/img/question"+stateData.contextQuestionsForUser[stateData.contextCurrentQuestion]+"/ico.svg"} alt="ico" className="answer__avaIco" /></div>
                    <div className="answer__name" dangerouslySetInnerHTML={{ __html: stateData.contextQuestions[stateData.contextQuestionsForUser[stateData.contextCurrentQuestion]].answers[stateData.contextQuestions[stateData.contextQuestionsForUser[stateData.contextCurrentQuestion]].correct] }} />
                </div>
                <div className="question__text" dangerouslySetInnerHTML={{ __html: stateData.contextQuestions[stateData.contextQuestionsForUser[stateData.contextCurrentQuestion]].text }} />
            </div>
            <div className={"question__answers question__answers--answer "+(stateData.contextQuestionsForUser[stateData.contextCurrentQuestion] === 1 ? 'question__answers--wide' : '')}>
                {stateData.contextQuestions[stateData.contextQuestionsForUser[stateData.contextCurrentQuestion]].answers.map((el, i) => { 
                    return (
                        <button className={"question__answer "+(
                                (stateData.contextQuestions[stateData.contextQuestionsForUser[stateData.contextCurrentQuestion]].correct) === i ? 'correct' :
                                      ( (stateData.contextUserAnswers[stateData.contextCurrentQuestion] === i) ? '' : 'wrong' )                          
                            )} type="button" onClick={()=>{ return false }} key={'qab'+i} dangerouslySetInnerHTML={{ __html: el }} />
                    ); 
                })}  
            </div>
            <div className="answer__next">
                <div className="answer__nextText"dangerouslySetInnerHTML={{ __html:  (stateData.contextUserAnswers[stateData.contextCurrentQuestion] === stateData.contextQuestions[stateData.contextQuestionsForUser[stateData.contextCurrentQuestion]].correct ? stateData.contextQuestions[stateData.contextQuestionsForUser[stateData.contextCurrentQuestion]].right : stateData.contextQuestions[stateData.contextQuestionsForUser[stateData.contextCurrentQuestion]].wrong) }} />
                <button type="button" className="btn answer__nextBtn" onClick={()=>{ 
                    //let keysArr = ['first','second','third','fourth','fifth','sixth','seventh','eighth'];
                    window["ym"](88899563,'reachGoal', 'game_guess_who_ClickNext', {screen: (stateData.contextCurrentQuestion+1)}); 
                    let pageTo = "../question";
                    if(stateData.contextCurrentQuestion < 4){
                        dispatchData({
                          type: "FETCH_CURRENT",
                          payload: stateData.contextCurrentQuestion+1
                        }) 
                    } else {
                        pageTo = "../results";
                    }
                    return navigate(pageTo, { replace: false }); }}>Продолжить</button>
            </div>
        </div>
    </>
  );
};

export default Answer;
